import React from 'react'
import { Link } from 'react-router-dom'

const HeaderEth = () => {
  return (
    <div className="Eth-Header">
      <div className="Eth-Img">
        <Link to="/">
          <img
            src="https://dbcms.docubay.com/media-upload/1715264355-telco.png"
            className="eth-head-img" />
        </Link>
      </div>
    </div>
  )
}

export default HeaderEth